import * as Yup from 'yup';
import BaseProductSchema from './BaseProductSchema';

/**
 * Validation schema for Admission ticket products
 * @param purchasedQuantity Number of tickets already purchased (for editing)
 */
const createAdmissionProductSchema = (purchasedQuantity = 0) => {
  const schema = Yup.object().shape({
    type: Yup.string()
      .required('Required field')
      .oneOf(['admission'], 'Must be an admission type'),
    ...BaseProductSchema,
    maxQuantity: Yup.mixed()
      .transform((value) => {
        if (value === '' || value === undefined || value === null) {
          return undefined;
        }
        const num = Number(value);
        return isNaN(num) ? undefined : num;
      })
      .optional()
      .test(
        'min-value',
        'You cannot decrease the number of available tickets to less than the number of tickets already sold.',
        function (value) {
          const { purchases } = this.parent;
          // Use purchases from FormValueDTO with fallback to purchasedQuantity parameter
          const soldTickets = purchases || purchasedQuantity;
          // Allow 0 (unlimited) or any value >= soldTickets
          return value === undefined || value === 0 || value >= soldTickets;
        }
      )
      .test(
        'max-value',
        'Value must not exceed 999999',
        (value) => value === undefined || value <= 999999
      )
      .label('Available Tickets'),
    purchaseRequirements: Yup.object()
      .shape({
        requiresApproval: Yup.boolean(),
        questions: Yup.array(
          Yup.object().shape({
            question: Yup.string()
          })
        ),
        requiredOrganizationIds: Yup.array(Yup.string()),
        requiredAssociationIds: Yup.array(Yup.string())
      })
      .required('Required field')
  });

  return schema;
};

export default createAdmissionProductSchema;
